import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router'
import { Modal, CircularProgress, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab'

// Styles
import '../../assets/styles.css'

// Firebase
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default function UsersControlComponent() {

    const history = useHistory()

    // Loading
    const [isLoadingModalOpen, setLoaginModalOpen] = useState(false)

    // Snackbar
    const [alertSeverity, setAlertSeverity] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertDuration, setAlertDuration] = useState(3000)
    const [alertOpen, setAlertOpen] = useState(false)

    function showAlert(severity, message, duration) {
        setAlertSeverity(severity)
        setAlertMessage(message)
        setAlertDuration(duration)
        setAlertOpen(true)
    }

    // Earning modal
    const [isEarningModalOpen, setEarningModalOpen] = useState(false)

    function checkedLogedIn() {
        firebase.auth().onAuthStateChanged((user) => {
            if(!user){
                history.replace('/login')
            } else {
                getUsers()
            }
        })
    }

    let usersList = []
    function getUsers() {

        usersList = []

        setLoaginModalOpen(true)
        firebase.firestore().collection('users').get().then((query) => {

            query.forEach((doc) => {
                const user = doc.data()
                
                usersList.push(user)
            })

            let html = ''

            if (usersList.length > 0) {
                
                usersList.forEach((user) => {

                    if(user.userType === 'user') {

                        html += '<div style="border: 1px solid #11898F; padding: 20px; border-radius: 5px;" >' +
                        '<h3 style="color: #FB3D44;" > Dr.' + user.fullName + ' </h3>' +
                        '<p style="line-height: 2; margin-left: 20px;" >' +
                        '- Cédula o pasaporte: <b>' + user.idCardNumber + '</b><br>' +
                        '- Nº teléfono: <b>' + user.phoneN + '</b><br>' +
                        '- E-mail: <b>' + user.email + '</b><br>' +
                        '- Tipo de usuario: <b>PERSONAL MÉDICO</b><br>'

                        if(user.wallet === undefined) {
                            html += '- Monedero: <b>00.00 $</b><br>'
                        } else {
                            html += '- Monedero: <b>' + user.wallet + ' $</b><br>'
                        }

                        if (user.verified === 'yes') {
                            html += '- Verificado: <b style="color: green;" >SI</b></br>' +
                            '</p>' +
                            '<div class=row >' +
                            '<div class="col" >' +
                            '<button type="button" class="btn btn-primary" id="' + user.appUserID + '-block" style="width: 100%; margin-top: 5px;" > BLOQUAR USUARIO </button>' +
                            '</div>' 
                        } else {
                            html += '- Verificado: <b style="color: red;" >NO</b></br>' +
                            '</p>' +
                            '<div class=row >' +
                            '<div class="col" >' +
                            '<button type="button" class="btn btn-primary" id="' + user.appUserID + '-block" style="width: 100%; margin-top: 5px;" disabled="true" > BLOQUAR USUARIO </button>' +
                            '</div>' 
                        }

                        html += '<div class="col" >' +
                        '<button type="button" class="btn btn-secondary" id="' + user.appUserID + '-earnings" style="width: 100%; margin-top: 5px;" > VER INGRESOS </button>' +
                        '</div>' +
                        '</div>' +
                        '</div><br>'

                    } else {

                        html += '<div style="border: 1px solid #11898F; padding: 20px; border-radius: 5px;" >' +
                        '<h3 style="color: #FB3D44;" > ' + user.establishmentName + ' </h3>' +
                        '<p style="line-height: 2; margin-left: 20px;" >' +
                        '- Responsable: <b>' + user.responsable + '</b><br>' +
                        '- Cédula o pasaporte responsable: <b>' + user.idCardNumber + '</b><br>' +
                        '- Nº teléfono: <b>' + user.phoneN + '</b><br>' +
                        '- E-mail: <b>' + user.email + '</b><br>' +
                        '- Nº RUC: <b>' + user.rucN + '</b><br>' +
                        '- Tipo de usuario: <b>LABORATORIO</b><br>'+
                        '- Dirección: <b>' + user.address + '</b><br>' +
                        '- Ciudad: <b>' + user.city + '</b><br>'

                        if(user.wallet === undefined) {
                            html += '- Monedero: <b>00.00 $</b></br>'
                        } else {
                            html += '- Monedero: <b>' + user.wallet + ' $</b></br>'
                        }

                        if (user.verified === 'yes') {
                            html += '- Verificado: <b style="color: green;" >SI</b></br>'
                        } else {
                            html += '- Verificado: <b style="color: red;" >NO</b></br>'
                        }

                        if(user.clinicalLaboratory) {
                            html += '- Laboratorio clinico: <b style="color: green;" > SI </b></br>'
                        } else {
                            html += '- Laboratorio clinico: <b style="color: red;" > NO </b></br>'
                        }

                        if(user.ecography) {
                            html += '- Ecografías: <b style="color: green;" > SI </b></br>'
                        } else {
                            html += '- Ecografías: <b style="color: red;" > NO </b></br>'
                        }

                        if(user.xRay) {
                            html += '- Rayos-X: <b style="color: green;" > SI </b></br>'
                        } else {
                            html += '- Rayos-X: <b style="color: red;" > NO </b></br>'
                        }

                        if (user.verified === 'yes') {
                            html += '</p>' +
                            '<div class=row >' +
                            '<div class="col" >' +
                            '<button type="button" class="btn btn-primary" id="' + user.appUserID + '-block" style="width: 100%; margin-top: 5px;" > BLOQUAR USUARIO </button>' +
                            '</div>' 
                        } else {
                            html += '</p>' +
                            '<div class=row >' +
                            '<div class="col" >' +
                            '<button type="button" class="btn btn-primary" id="' + user.appUserID + '-block" style="width: 100%; margin-top: 5px;" disabled="true" > BLOQUAR USUARIO </button>' +
                            '</div>' 
                        }

                        html += '<div class="col" >' +
                        '<button type="button" class="btn btn-secondary" id="' + user.appUserID + '-earnings" style="width: 100%; margin-top: 5px;" > VER INGRESOS </button>' +
                        '</div>' +
                        '</div>' +
                        '</div><br>'

                    }

                })

                setLoaginModalOpen(false)
                document.getElementById('listBody').innerHTML = html

                // Funcion para bloquear usuarios.
                usersList.forEach((user) => {

                    document.getElementById(user.appUserID + '-block').addEventListener('click', () => {

                        setLoaginModalOpen(true)

                        firebase.firestore().collection('users').doc(user.appUserID.toString()).update({verified : 'no'}).then(() => {

                             document.getElementById(user.appUserID + '-block').disabled = true
                             setLoaginModalOpen(false)

                             showAlert('success', 'Usuario bloqueado, solo podrá acceder a los ajustes de su cuenta. Para desbloquearlo vuelve a verificarlo en el panel "Verificación de usuarios."', 10000)

                        })

                    })

                })

                // Función para ver una lista de ingresos de ususario.
                usersList.forEach((user, index) => {

                    document.getElementById(user.appUserID + '-earnings').addEventListener('click', () => {
                        if(user.earnings === undefined) {
                            showAlert('warning', 'Este usuario no tiene ingresos aún.', 3000)
                        } else {
                            getSelectedUserEarning(index)
                        }
                    })
                })

            } else {
                setLoaginModalOpen(false)
                showAlert('warning', 'No hay usuarios registrados!', 3000)
                document.getElementById('listBody').innerHTML = html
            }

        }).catch((error) => {
            console.error(error)
            showAlert('error', 'Ha ocurrido un error al intentar recuperar los usuarios, inténtalo más tarde.', 4000)
        })
    }

    function getSelectedUserEarning(index) {
        setEarningModalOpen(true)

        const selectedUser = usersList[index]

        const earnings = selectedUser.earnings

        let name = ''

        if (selectedUser.userType === 'user') {
            name = selectedUser.fullName
        } else {
            name = selectedUser.establishmentName
        }

        document.getElementById('selectedUsername').innerHTML = 'Ingresos de ' + name

        earnings.reverse()
        let html = ''
        earnings.forEach((earning) => {

            const x = earning.key
            const y = x.split('-')
            const timestamp = y[0]
            const date = timeConverter(timestamp)

            html += '<li>' +
                '<div>' +
                '<p>' + date + '<br>' +
                '<b style="color: green;" >+ ' + earning.earning + ' $</b></p>' +
                '</div></li>' 

        })

        document.getElementById('earningList').innerHTML = html
    }

    function timeConverter(UNIX_timestamp) {
        var a = new Date(UNIX_timestamp * 1000);
        var year = a.getFullYear();
        var month = a.getMonth() + 1;
        var date = a.getDate();
        var time = date + '-' + month + '-' + year
        return time;
    }

    useEffect(() => {
        checkedLogedIn()
    }, [])

    return(
        <div>
            <br></br>
            <div className="container" >
                <div className="row" >
                    <div className="col text-center" >
                        <h1 style={{ color: '#FB3D44'}} >
                            CONTROL DE USUARIOS
                        </h1>
                    </div>
                </div>
                <div className='row blue-divider'></div>
                <br></br>
                <div className='row' >
                    <div className='col-1' ></div>
                    <div className='col-10' >
                        <ul className='list-group' id='listBody' >
                        </ul>
                    </div>
                    <div className='col-1' ></div>
                </div>
            </div>
            <br></br>
            {/**
             * 
             * MODAL ZONE
             * 
             */}
            <Modal
            disableEnforceFocus
            open={isLoadingModalOpen} >
                <div style={{ display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center'}} >
                    <CircularProgress color='inherit' style={{ color: '#FB3D44', marginTop: 25 }} />
                </div>
            </Modal>

            <Modal
            disableEnforceFocus
            open={isEarningModalOpen} >
                <div style={{ display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center'}} >
                    <div style={{ backgroundColor: 'white', padding: 20, borderRadius: 5, display: 'flex', flexDirection: 'column'}} >
                        <button 
                        type='button' 
                        className='btn' 
                        style={{ alignSelf: 'flex-end', color:'gray', marginRight: -10, marginTop: -10 }}
                        onClick={() => { 
                            setEarningModalOpen(false)
                        }} >
                            <i className="fas fa-times"></i>
                        </button>
                        <h4 style={{ color: '#FB3D44'}} id='selectedUsername' >
                            Ingresos de 
                        </h4>
                        <div className='blue-divider' ></div>
                        <ul id='earningList' style={{ overflowY: 'scroll', height: 300 }} >

                        </ul>
                    </div>
                </div>
            </Modal>
            {/**
             * 
             * SNACKBAR
             * 
             */}
            <Snackbar
            open={alertOpen}
            autoHideDuration={alertDuration}
            onClose={() => {
                setAlertOpen(false)
            }} >
                <Alert 
                variant='filled'
                severity={alertSeverity} >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/usersControl/UsersControlComponent.js